// src/pages/AdminDashboard/Tasks/TaskDetails.jsx
import { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import AdminNavBar from "../../pages/Admin/NavBar/AdminNavBar";
import style from './TaskFullView.module.css'

export default function TaskDetails() {
    const { taskId, employeeId } = useParams(); // get params from URL
    const [task, setTask] = useState({});
    const [error, setError] = useState("");

    const apiurl = process.env.REACT_APP_SERVER_URL;
    const token = localStorage.getItem("token");
    const [loading, setLoading] = useState(true);

    const navigate = useNavigate();

    useEffect(() => {
        if (!apiurl) {
            setError("API is not working");
            return;
        }

        fetch(`${apiurl}/tasks/${taskId}`, {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json",
            }
        })
            .then((res) => res.json())
            .then((data) => {
                setTask(data.task);
                setLoading(false);
            })
            .catch((err) => { setError(err.message); setLoading(false); });
    }, [apiurl, taskId]);

    const handleDelete = async () => {
        if (window.confirm("Are you sure you want to delete this project?")) {
            try {
                const response = await fetch(`${apiurl}/tasks/${taskId}`, {
                    method: "DELETE",
                    headers: {
                        "Authorization": `Bearer ${token}`,
                        "Content-Type": "application/json",
                    }
                });
                if (response.ok) {
                    alert("Task deleted successfully");
                    navigate(`/admin-dashboard/${employeeId}/all-Tasks`);
                } else {
                    const result = await response.json();
                    alert(result.message || "Failed to delete Task");
                }
            } catch (err) {
                alert(err.message);
            }
        }
    };

    if (error) return <p className="text-danger">{error}</p>;

    return (
        <div className="container pt-lg-4">
            <AdminNavBar />

            <div className="mt-lg-1 mb-3">
                <span><Link to={`/admin-dashboard/${employeeId}`} className={style.breadcrumb} style={{ textDecoration: 'none' }}>Dashboard <i class="bi bi-caret-right-fill"></i></Link></span>
                <span><Link to={`/admin-dashboard/${employeeId}/all-tasks`} className={style.breadcrumb} style={{ textDecoration: 'none' }}>All Tasks <i class="bi bi-caret-right-fill"></i></Link></span>
                <span><Link to={`/admin-dashboard/${employeeId}/all-tasks/${taskId}`} className={style.breadcrumb} style={{ textDecoration: 'none' }}>{task.title} </Link></span>
            </div>
            <div className={style.FullViewPage}>
                <div className="card p-4 shadow">
                    <h6 className="mb-3 ps-4 text-center">
                        {loading ?
                            <>
                                <span className="w-25 placeholder placeholder-xs"></span>
                            </>
                            :
                            <>
                                <b>{`${task.title} `}</b> Details
                            </>}
                    </h6>
                    <table className="table table-hover table-striped">
                        {
                            loading ?
                                <>
                                    <tbody>
                                        {Array.from({ length: 10 }).map((_, idx) => {
                                            return (
                                                <>
                                                    <tr key={idx} >
                                                        <td className=" text-center">
                                                            <span className="w-25 placeholder placeholder-xs"></span>
                                                        </td>
                                                        <td className=" text-center">
                                                            <span className="w-25 placeholder placeholder-xs"></span>
                                                        </td>

                                                    </tr>

                                                </>
                                            )
                                        })}
                                    </tbody>
                                </>
                                :
                                <>
                                    <tbody>
                                        <tr>
                                            <td className="ps-4" style={{ width: '50%' }}>Title</td>
                                            <td className="ps-4">{task.title}</td>
                                        </tr>
                                        <tr>
                                            <td className="ps-4">Status</td>
                                            <td className="ps-4">{task.status}</td>
                                        </tr>
                                        <tr>
                                            <td className="ps-4">Priority</td>
                                            <td className="ps-4">{task.priority}</td>
                                        </tr>
                                        <tr>
                                            <td className="ps-4">Assigned By</td>
                                            <td className="ps-4">{task.assignedBy}</td>
                                        </tr>
                                        <tr>
                                            <td className="ps-4">Assigned For</td>
                                            <td className="ps-4">{task.employeeId?.join(", ")}</td>
                                        </tr>
                                        <tr>
                                            <td className="ps-4">Finishing Date</td>
                                            <td className="ps-4">{task.finishingDate}</td>
                                        </tr>
                                        <tr>
                                            <td className="ps-4">Finishing Time</td>
                                            <td className="ps-4">{task.finishingTime}</td>
                                        </tr>
                                        <tr>
                                            <td className="ps-4">Preferences</td>
                                            <td className="ps-4"> {task.preferences}</td>
                                        </tr>
                                        <tr>
                                            <td className="ps-4">Description</td>
                                            <td className="ps-4">{task.description}</td>
                                        </tr>
                                        <tr>
                                            <td className="ps-4 text-center"  >
                                                <button
                                                    className="btn btn-warning"
                                                >
                                                    <Link to={`/admin-dashboard/${employeeId}/update-task/${taskId}`} style={{ color: 'none', textDecoration: 'none' }}>
                                                        update
                                                    </Link>
                                                </button>
                                            </td>

                                            <td className="ps-4  text-center"  >
                                                <button
                                                    className="btn btn-danger"
                                                    onClick={handleDelete}
                                                >
                                                    Delete
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </>
                        }
                    </table>
                </div>
            </div>
        </div >
    );
}
